import React, { useState, useEffect } from "react";
import Header from "../../components/ui/Header";
import Sidebar from "../../components/ui/Sidebar";
import Button from "../../components/ui/Button";
import Icon from "../../components/AppIcon";
import UserStatsPanel from "./components/UserStatsPanel";
import UserFilters from "./components/UserFilters";
import IndividualUsersTable from "./components/IndividualUsersTable";
import TeamUsersTable from "./components/TeamUsersTable";
import UserModal from "./components/UserModal";
import { useGetallFunctionQuery } from "store/dynamicApi";

const TokenManagement = () => {
  const { data, isLoading } = useGetallFunctionQuery({ url: "/users/tokens" });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Sidebar />

      <main className="lg:ml-60 pt-16">
        <div className="p-6">
          {/* Page Header */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-8">
            <div>
              <h1 className="text-2xl font-bold text-text-primary mb-2">
                Token Management
              </h1>
              <p className="text-text-muted">
                Manage individual and team user accounts, card assignments, and
                access permissions
              </p>
            </div>
            <div className="flex items-center space-x-3 mt-4 lg:mt-0">
              <Button variant="outline" iconName="Download" iconPosition="left">
                Export Users
              </Button>
              <div className="relative">
                <div
                  id="add-user-dropdown"
                  className="absolute right-0 top-full mt-2 w-48 bg-surface border border-border rounded-lg shadow-elevation-3 z-50 hidden"
                >
                  <div className="p-2">
                    <button
                      onClick={() => {
                        handleAddUser("individual");
                        document
                          .getElementById("add-user-dropdown")
                          .classList.add("hidden");
                      }}
                      className="w-full flex items-center px-3 py-2 text-sm text-text-primary hover:bg-hover rounded-lg transition-colors duration-150"
                    >
                      <Icon name="User" size={16} className="mr-3" />
                      Individual User
                    </button>
                    <button
                      onClick={() => {
                        handleAddUser("team");
                        document
                          .getElementById("add-user-dropdown")
                          .classList.add("hidden");
                      }}
                      className="w-full flex items-center px-3 py-2 text-sm text-text-primary hover:bg-hover rounded-lg transition-colors duration-150"
                    >
                      <Icon name="Users" size={16} className="mr-3" />
                      Team User
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full border rounded-lg overflow-hidden">
              <thead className="bg-gray-100 text-[#0A0A0A]">
                <tr>
                  <th className="text-left px-4 py-2 border">ID</th>
                  <th className="text-left px-4 py-2 border">Email</th>

                  <th className="text-left px-4 py-2 border">Url</th>
                </tr>
              </thead>
              <tbody className="text-gray-200">
                {data?.map((user, i) => (
                  <tr key={user?._id} className="hover:bg-[#161616]">
                    <td className="px-4 py-2 border">{i + 1}</td>
                    <td className="px-4 py-2 border">{user?.email}</td>

                    <td className="px-4 py-2 border">{user?.url}</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TokenManagement;
